import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Routes } from '@configs/routes';
import { AuthService } from '@services/auth.service';

export const authorizedUserGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) return true;

  router.navigate([Routes.SignIn]);

  return false;
};
